import { IonIcon } from "@ionic/react";
import cn from "classnames";
import { arrowBack } from "ionicons/icons";
import React from "react";
import { useHistory, useLocation } from "react-router";

interface BackButtonProps {
  buttonStyles?: string;
  iconStyles?: string;
  onClickButton?: () => void;
}

const BackButton = ({ buttonStyles, iconStyles, onClickButton }: BackButtonProps) => {
  const history = useHistory();
  const location = useLocation<{ from?: string }>();

  const handleBack = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    if (onClickButton) {
      onClickButton();
      return;
    }

    if (history.length > 1 && location.state?.from !== "notification") {
      console.log("go back");
      history.go(-1);
    } else {
      console.log("replace home");
      history.replace("/home3");
    }
  };

  return (
    <button
      type="button"
      onClick={(e) => handleBack(e)}
      className={cn(
        "flex bg-[#f4f4f4] border-0 rounded-full px-[15px] text-4.5 py-[3px] focus-visible:outline-none",
        buttonStyles,
      )}
    >
      <IonIcon className={cn("ion-no-margin", iconStyles)} icon={arrowBack} color="gray" />
    </button>
  );
};

export default BackButton;
